'use strict';

goog.provide('Ntry.Ebs2015Result');

goog.require('Ntry.STATIC');
goog.require('Ntry.Engine');

Ntry.Ebs2015Result = function() {
    this._view = Ntry.interfaceManager.getDom('ntryResultArea');
    this.createDom();
};

(function(p) {
    p._ebsId_counts = [3, 4, 4];

    p.createDom = function() {
        const parent = this._view;
        const container = Ntry.createElement('div', parent, null, 'ntryResultContainer');
        this._container = container;
        const title = Ntry.createElement('div', container, null, 'ntryResultTitle');
        this._closeButton = Ntry.createElement('span', title, null, 'ntryResultCloseButton');
        this._closeButton.innerHTML = '닫기';

        const content = Ntry.createElement('div', container, null, 'ntryResultContent');
        this._leftImg = Ntry.createElement('div', content, null, 'ntryResultLeftImg');

        const rightDiv = Ntry.createElement('div', content, null, 'ntryResultRightDiv');
        this._successContent = Ntry.createElement('div', rightDiv, null, 'ntryResultRightContent');

        this._failContent = Ntry.createElement('div', rightDiv, null, 'ntryResultRightContent');
        this._failCauseString = Ntry.createElement(
            'span',
            this._failContent,
            null,
            'ntryResultFailCauseSpan'
        );
        this._essentialBlocks = Ntry.createElement(
            'div',
            this._failContent,
            null,
            'ntryResultEssentialBlocks'
        );

        this._replayButton = Ntry.createElement('span', content, null, 'ntryResultReplayButton');
        this._replayButton.innerHTML = '다시하기';

        this._nextButton = Ntry.createElement('span', content, null, 'ntryResultNextButton');
        this._nextButton.innerHTML = '다음단계 가기';

        this._finalButton = Ntry.createElement('span', content, null, 'ntryResultFinalButton');
        this._finalButton.innerHTML = Lang.Menus.go_further;
        this._finalButton.addClass('ntryRemove');
    };

    p.update = function() {};

    p.loadConfig = function() {
        Ntry.addEventListener('complete', this, this.complete);
    };

    p.complete = function(success, cause) {
        const stageIdString = Ntry.configManager.getConfig('stageId');
        const stageIds = stageIdString.split('-');

        const stageId = Number(stageIds[0]);
        const stepId = Number(stageIds[1]);

        this._leftImg.removeClasses();
        this._leftImg.addClass('ntryResultLeftImg');

        const self = this;
        this._closeButton.bindOnClick(() => {
            $(self._view).css('display', 'none');
        });

        this._replayButton.bindOnClick(() => {
            Ntry.dispatchEvent('replay');
            $(self._view).css('display', 'none');
        });

        this._container.removeClasses();
        this._container.addClass('ntryResultContainer');
        if (success) {
            const isEssentialUsed = this.inspectEssential();
            if (isEssentialUsed) {
                this.success(stageId, stepId);
            } else {
                this.fail(stageId, stepId, Ntry.STATIC.ESSENTIAL_REQUIRED);
            }
        } else {
            this.fail(stageId, stepId, cause);
        }

        $(this._view).css('display', 'block');
    };

    p.inspectEssential = function() {
        const essentialBlockInfo = Ntry.configManager.getConfig('essentialBlockInfo');
        if (_.isEmpty(essentialBlockInfo)) {
            return true;
        }

        const entityManager = Ntry.entityManager;
        const entities = entityManager.getEntitiesByComponent(Ntry.STATIC.SCRIPT_CONTAINER);
        if (_.isEmpty(entities)) {
            return false;
        }

        const restoreComp = entityManager.getComponent(
            _.first(_.keys(entities)),
            Ntry.STATIC.RESTORE
        );
        if (!restoreComp) {
            return true;
        }

        let restoreScript = Blockly.mainWorkspace.getTopBlocks(Blockly.mainWorkspace);
        if (!restoreScript) {
            return true;
        }

        const blocks = _.filter(restoreScript, (b) => {
            const type = b.type;
            const headBlocks = [
                'ai_start',
                'ai_start_un',
                'maze_step_start',
                'maze_step_unstart',
                'maze_define_unfunction',
                'maze_define_function',
            ];
            return headBlocks.indexOf(type) > -1;
        });

        restoreScript = _.reduce(
            blocks,
            (a, b) => {
                const txt = Blockly.Xml.domToText(Blockly.Xml.blockToDom_(b));
                return a + txt;
            },
            ''
        );

        /* inspect all essentialBlocks pass regex for
         * restore block script
         */
        let matchCnt = 0;
        for (let i = 0, len = essentialBlockInfo.blocks.length; i < len; i++) {
            if (new RegExp(essentialBlockInfo.blocks[i], 'i').test(restoreScript)) {
                matchCnt++;
            }
        }

        return matchCnt >= essentialBlockInfo.matchCnt;
    };

    p.success = function(stageId, stepId) {
        var stageId = Number(stageId);
        const maxStep = this._ebsId_counts[stageId - 1];
        if (stepId === maxStep) {
            this._leftImg.addClass('ntryResultSuccess2Img');
            this._finalButton.bindOnClick(() => {
                switch (stageId) {
                    case 1:
                        window.location.href = '/le/55dfff4a798ef40c00475e0b';
                        break;
                    case 2:
                        window.location.href = '/le/55e43b0b7e65fe11007078d8';
                        break;
                    case 3:
                        window.location.href = '/le/55fb78e73f115b047b3aa9ce';
                        break;
                    default:
                        window.location.href = '/le/55f2bc9d053dab150075be83';
                        break;
                }
            });
            switch (stageId) {
                case 1:
                    this._successContent.innerHTML =
                        '소피야~ 멋지게 심부름을 성공해줘서 고마워!<br/> 네가 내 친구여서 정말 좋아!';
                    break;
                case 2:
                    this._successContent.innerHTML =
                        '소피야~ 오늘 함께 놀아서 정말 즐거웠어! 다음에 또 같이 놀자!';
                    break;
                case 3:
                    this._successContent.innerHTML =
                        '소피야~ 너의 미로찾기 실력, 정말 멋진걸?<br/> 덕분에 길을 잃지 않았어. 고마워!';
                    break;
            }

            this._nextButton.ntryRemove();
            this._replayButton.removeClasses();
            this._finalButton.removeClass('ntryRemove');
            this._replayButton.addClass('ntryResultReplayButtonTryMore');
        } else {
            this._successContent.innerHTML = '소피, 멋지게 미션 성공!';
            this._leftImg.addClass('ntryResultSuccess1Img');
            this._nextButton.bindOnClick(() => {
                window.location.href = `/ebs_2015#!/${stageId}/${stepId + 1}`;
            });

            this._nextButton.ntryShow();
            this._replayButton.removeClasses();
            this._replayButton.addClass('ntryResultReplayButton');
        }

        this._successContent.ntryShow();
        this._failContent.ntryRemove();
    };

    p.fail = function(stageId, stepId, cause) {
        this._essentialBlocks.removeClasses();
        this._essentialBlocks.ntryRemove();

        let causeString = '앗, 미션을 완료하지 못했쟎아? 다시 한 번 해보자!';
        if (stageId === 3 && stepId === 4 && cause === Ntry.STATIC.ESSENTIAL_REQUIRED) {
            this._container.removeClasses();
            this._container.addClass('ntryResultContainerTaller');
        } else {
            this._container.removeClasses();
            this._container.addClass('ntryResultContainer');
        }
        switch (cause) {
            case Ntry.STATIC.ESSENTIAL_REQUIRED:
                causeString = '꼭 사용해야 하는 블록을 사용하지 않았어. 다시 한 번 해보자!';
                this.renderBlocks(stageId, stepId);
                break;

            case Ntry.STATIC.SEQUENCE_SIMOOROOK:
                causeString = '앗, 사과를 사지 않고 할머니댁에 왔잖아? 다시 한 번 해보자!';
                break;
        }

        this._leftImg.addClass('ntryResultFailImg');
        this._failCauseString.innerHTML = causeString;
        this._failContent.ntryShow();

        this._successContent.ntryRemove();
        this._nextButton.ntryRemove();

        this._replayButton.removeClasses();
        this._replayButton.addClass('ntryResultReplayButtonFailed');
    };

    p.renderBlocks = function(stageId, stepId) {
        this._essentialBlocks.removeClasses();
        this._essentialBlocks.addClass('ntryResultEssentialBlocks');
        this._essentialBlocks.addClass(`ntryResultEssentialBlock_${stageId}_${stepId}`);
    };
})(Ntry.Ebs2015Result.prototype);
